<template>

  <t-page>

    <t-page-form card :submit-text="'Dados Básicos'"
                 :title="'Alterar Dados Básicos e Histórico'"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <t-input v-model="form.name"  label="Nome" required/>


      <t-msg info>Últimos Acessos</t-msg>

      <b-table hover :items="history" :fields="historyFields">

        <template #cell(loginDate)="{item}">
          {{ item.loginDate | datetime }}
        </template>


      </b-table>


    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import myUserService from "@/services/modules/general/MyUser.service";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'MyUserHistory',
  data() {
    return {
      path: "general/my-user/changeBasicInformation", //Utilizar somente quando fora do padrão
      generalResource: true, //Página de recurso geral
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "",
      pageTitle: "Dados Básicos e Histórico",
      user: {
        username: "",
        name: "",
        profile: "",
        department: "",
        initials: "",
      },
      form: {
        name: "",
      },
      history: [],
      historyFields: [
        {
          key: "platform",
          label: "Plataforma"
        },
        {
          key: "loginDate",
          label: "Data do Login"
        },
        {
          key: "ip",
          label: "IP"
        },
        {
          key: "city",
          label: "Cidade (aprox.)"
        },
        {
          key: "country",
          label: "País"
        },
        {
          key: "server",
          label: "Servidor"
        },
      ],
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      this.command = 'update'

      await myUserService.get().then((my_user) => {
        this.user = my_user.user
        this.form.name = this.user.name
        this.history = my_user.history
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true


    },
    async onSubmit() {

      this.status = "sending"

      //Crud enviado, por tanto será feito de forma automatica a inclusão e alteração
      await crudGeneral.save(this.getPath(), this.command, this.form).then(() => {

        ui.msg(this, 'Informação', 'Dados básicos alterados com sucesso!', () => {
          ui.reload();
        })

      }).catch(error => {

        if (error.response) {

          if (error.response.status === 401) {
            ui.msg(this, 'Informação', 'Senha atual informada não está correta')
          } else if (error.response.status === 500) {
            ui.msg(this, 'Informação', error.response.data.message)
          }

          this.form.oldPassword = ''
          this.form.newPassword = ''

          this.status = "subject"

        }

      })


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(false, true)

    await this.mountedContinued()

  },

}
</script>
